import { Snackbar, styled } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import { useLinked } from "@type-r/react";
import { Column, Columns, Flex, div, navigate } from "lqx-react";
import React from "react";
import { ValidationRuleDetails } from "../../api/validationRuleDetails";
import {
  BackButton, CancelButton,
  ConfirmationButton,
  RightAlignedButtons, StartOverButton, WorkflowBody, WorkflowFooter, WorkflowTitle
} from "../../shared";
import { TransferList } from "./transfer-list";


export const ValidationRuleDuplicationCheckStep =
  ({ back, cancel, startOver, validationRuleDetails }:
    { back?, cancel?, startOver?, validationRuleDetails?: ValidationRuleDetails }) => {

    const $showErrors = useLinked(false);
    const $errorMessage = useLinked("Error happened!");
    const $disableSave = useLinked(false);
    const isEdit = validationRuleDetails.id ? true : false;
    const handleCloseShowErrors = (_, reason) => {
      if (reason === 'clickaway') {
        return;
      }
      $showErrors.set(false);
      $errorMessage.set("Error happened!");
    };

    const save = () =>
      validationRuleDetails
        .save()
        .then(() => navigate('validation-rules'))
        .catch(err => {
          $showErrors.set(true);
          $errorMessage.set(err.message);
          $disableSave.set(false);
          return;
        });

    return (
      <>
        <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={$showErrors.value} autoHideDuration={6000} onClose={handleCloseShowErrors}>
          <Alert severity="error">
            <AlertTitle>Error during saving</AlertTitle>
            {$errorMessage.value}
          </Alert>
        </Snackbar>
        <WorkflowTitle>
          Step 3: Define Your Validation Duplication Checks
        </WorkflowTitle>
        <WorkflowBody>
          <ValidationBodyContainer>
            <FlexBody row>
              <MainContainer>
                <PlateHeader>
                  <Column>
                    <span>Duplication Checks</span>
                  </Column>
                </PlateHeader>
                <PlateContainer>
                  <TransferList validationRuleDetails={validationRuleDetails} />
                </PlateContainer>
              </MainContainer>
            </FlexBody>
          </ValidationBodyContainer>
        </WorkflowBody>
        <WorkflowFooter>
          <Columns>
            <Column>
              <Flex row>
                <CancelButton color="primary" onClick={cancel}>Cancel</CancelButton>
                {isEdit ? <></> : <StartOverButton color="primary" onClick={startOver}>Start Over</StartOverButton>}
              </Flex>
            </Column>
            <Column>
              <RightAlignedButtons>
                <BackButton color="primary" onClick={back}>Back</BackButton>
                <ConfirmationButton disabled={$disableSave.value} onClick={() => {
                  $disableSave.set(true);
                  save();
                }}>Save Validation Sets</ConfirmationButton>
              </RightAlignedButtons>
            </Column>
          </Columns>
        </WorkflowFooter>
      </>
    );
  };

const FlexBody = styled(Flex)({
  overflow: 'auto',
  flex: '1 1 auto'
})

const ValidationBodyContainer = div({
  display: 'flex',
  marginTop: '15px',
  justifyContent: 'center',
  width: '100%',
  flexDirection: 'column',
  alignItems: 'stretch',
  minHeight: 'calc(100% - 220px)',
  maxHeight: 'calc(100% - 220px)',
  paddingBottom: '25px',
  overflow: 'auto'
});

const MainContainer = styled(Column)({
  flex: '1 0 450px',
  overflow: 'auto',
  borderLeft: '1px solid whitesmoke',
  background: 'white'
});

const PlateHeader = div({
  display: 'Flex',
  height: '50px',
  background: '#052C4C',
  width: 'auto',
  alignItems: 'center',
  color: 'white'
});

const PlateContainer = div({
  borderRadius: '4px',
  padding: '8px',
  justifyContent: 'center',
  maxHeight: 'calc(100% - 50px)'
});

const FieldRow = div({
  display: 'flex',
  flexDirection: 'row',
  backgroundColor: 'whitesmoke',
  marginTop: 5,
  marginBottom: 3,
  borderRadius: 5,
  padding: '10px 10px',
  fontSize: '12px',
  fontFamily: 'Montserrat',
  fontWeight: 500,
});

const CloseBtn = div({
  marginLeft: 'auto',
  alignSelf: 'center',
  height: '22px',
  cursor: 'pointer'
});

const BaseColumn = styled(Column)({
  color: '#668AA5',
  fontSize: '14px',
  fontWeight: 600
})

const FieldNameColumn = styled(BaseColumn)({
  flex: '0.5'
})